import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

function Footer() {
  return (
    <footer className="footer">
      {/* Decorative background elements */}
      <div className="footer-decoration footer-decoration-1"></div>
      <div className="footer-decoration footer-decoration-2"></div>

      <div className="footer-wrapper">

        {/* Main Content Grid */}
        <div className="footer-content">
          {/* About Section */}
          <div className="footer-section footer-about">
            <h3>Sobre Nosotros</h3>
            <p>Distribuidores mayoristas de materias primas, equipos y servicios comerciales de primera calidad con amplia experiencia en el sector.</p>
            <div className="footer-highlight">
              ✓ Amplia experiencia comprobada
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section footer-links">
            <h3>Enlaces Rápidos</h3>
            <ul>
              <li><Link to="/">Inicio</Link></li>
              <li><Link to="/contacto">Contacto</Link></li>
              <li><Link to="/terminos-condiciones">Términos y Condiciones</Link></li>
              <li><Link to="/politica-privacidad">Política de Privacidad</Link></li>
            </ul>
          </div>

          {/* Contact Information */}
          <div className="footer-section footer-contact">
            <h3>Contacto</h3>
            <div className="contact-item">
              <span className="contact-icon" aria-hidden="true">📧</span>
              <div>
                <p className="contact-label">Email</p>
                <a href="mailto:Atencionaclientes@narek.mx">Atencionaclientes@narek.mx</a>
              </div>
            </div>
            <div className="contact-item">
              <span className="contact-icon" aria-hidden="true">📱</span>
              <div>
                <p className="contact-label">Teléfono</p>
                <a href="tel:+528180108415">81 8010 8415</a>
              </div>
            </div>
            <div className="contact-item">
              <span className="contact-icon" aria-hidden="true">📍</span>
              <div>
                <p className="contact-label">Dirección</p>
                <span style={{ color: '#D4AF37', fontSize: '0.9rem' }}>OVYE BUSINESS CENTER, San Pedro Garza García, NL</span>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom Section */}
        <div className="footer-bottom">
          <div className="footer-divider"></div>
          <div className="footer-bottom-content">
            <p className="copyright">&copy; Comercial y Servicios Narek S.A. de C.V. Todos los derechos reservados.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
